// Backend API base URL, injected at build time from REACT_APP_API_URL
// (see .env.example). No trailing slash.
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NODE_ENV === 'production') {
    return 'https://api.veracity.zyen.info';
  }
  return 'http://localhost:8000';
};

export const Baseurl = getApiUrl().replace(/\/+$/, '');
